const CheckIcon = ({ color }: { color: string }) => (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="check-glow">
                <feGaussianBlur stdDeviation="1" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <g filter="url(#check-glow)">
            <path
                d="M29.7718 54.5816C43.4739 54.5816 54.5816 43.4739 54.5816 29.7718C54.5816 16.0697 43.4739 4.96191 29.7718 4.96191C16.0697 4.96191 4.96191 16.0697 4.96191 29.7718C4.96191 43.4739 16.0697 54.5816 29.7718 54.5816Z"
                stroke={color}
                strokeWidth="4.46576"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.3291 29.7715L27.2911 34.7335L37.215 24.8096"
                stroke={color}
                strokeWidth="4.46576"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default CheckIcon;
